import {KeypadGameConfig} from "@nolimitcity/slot-keypad/bin/core/config/KeypadGameConfig";
import {KeypadButtonIDs} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {LonerSound} from "./sound/LonerSound";
import {Loner} from "./Loner";

export class LonerKeypadGameConfig implements KeypadGameConfig {
    constructor() {
    }

    playKeypadButtonSound(id: KeypadButtonIDs | string): boolean {
        const btnId: string = id;
        if (btnId === "RemoveSelectedFeature") {
            Loner.soundPlayer.playSound(LonerSound.XBET_OFF);
            return false;
        } else if (btnId === "nolimitBonusMenu") {
            Loner.soundPlayer.playSound(LonerSound.XBET_ON);
            return false;
        } else {
            return true
        }
    }
}